import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Commandments from "@/components/Commandments";
import VoltageMatrix from "@/components/VoltageMatrix";
import About from "@/components/About";
import FinalCta from "@/components/FinalCta";
import IntakeForm from "@/components/IntakeForm";
import Footer from "@/components/Footer";

function MethodIntro() {
  return (
    <section id="method" className="bg-ink py-24 sm:py-32" data-testid="method-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <p className="text-[11px] uppercase tracking-[0.35em] text-copper-hover mb-6" data-testid="method-eyebrow">
          The Premise
        </p>
        <p className="font-serif text-2xl sm:text-4xl lg:text-[2.75rem] text-neutral-200 font-light leading-[1.35] tracking-tight">
          “You do not have a discipline problem.{" "}
          <span className="text-gold italic">You have a voltage problem.</span>{" "}
          Restore the cell, and the executive returns automatically.”
        </p>
        <div className="gold-divider mt-10 max-w-xs mx-auto" />
      </div>
    </section>
  );
}

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App bg-ink text-neutral-200 antialiased" data-testid="app-root">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <MethodIntro />
        <Commandments />
        <VoltageMatrix />
        <About />
        <FinalCta />
        <IntakeForm />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
